import { isMobile } from "react-device-detect";
import { useContext, useState } from "react";
import { LoadingContext } from "../../../../../contexts/loadingContext";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import ReactInputMask from "react-input-mask";

import "./step-2.scss";

const schema = yup.object().shape({
  cep: yup
    .string()
    .matches(/^\d{5}-\d{3}$/, "Digite um CEP válido!")
    .required("CEP é uma informação obrigatória!"),
  endereco: yup.string().required("O campo endereço é obrigatório."),
  numero: yup.string().required("O campo número é obrigatório."),
  complemento: yup.string(),
  bairro: yup.string().required("O campo bairro é obrigatório."),
  cidade: yup.string().required("O campo cidade é obrigatório."),
  estado: yup.string().required("O campo estado é obrigatório."),
});

function Step2({ prevStep, nextStep }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { setIsLoadingGlobal } = useContext(LoadingContext);

  const handleCepBlur = async (e) => {
    const cleanedCEP = e.target.value.replace("-", "");
    if (cleanedCEP.length === 8) {
      try {
        setIsLoadingGlobal(true);
        const response = await axios.get(
          `https://viacep.com.br/ws/${cleanedCEP}/json/`
        );
        if (response.erro) {
          alert("CEP não encontrado");
          return;
        }
        setValue("endereco", response.data.logradouro);
        setValue("bairro", response.data.bairro);
        setValue("estado", response.data.estado);
        setValue("cidade", response.data.localidade);
      } catch (error) {
        console.error("Erro ao buscar o CEP: ", error);
      } finally {
        setIsLoadingGlobal(false);
      }
    }
  };

  const onSubmit = (data) => {
    data.cep = data.cep.replace(/\D/g, "");
    nextStep(data);
  };

  return (
    <form className="form step-2" onSubmit={handleSubmit(onSubmit)}>
      <div className={`${isMobile ? "" : "row"}`}>
        <div className="col mb-4">
          <label htmlFor="cep" className="form-label">
            CEP
          </label>
          <ReactInputMask
            className="form-control"
            mask="99999-999"
            placeholder="Digite seu CEP"
            maskChar={null}
            {...register("cep")}
            onBlur={handleCepBlur}
          >
            {(inputProps) => <input {...inputProps} />}
          </ReactInputMask>
          {errors.cep ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.cep.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={`${isMobile ? "" : "col-8"} mb-4`}>
          <label htmlFor="endereco" className="form-label">
            Endereço
          </label>
          <input
            type="text"
            className="form-control"
            id="endereco"
            placeholder="Informe antes seu CEP"
            {...register("endereco")}
          />
          {errors.endereco ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.endereco.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className={`${isMobile ? "" : "row"}`}>
        <div className="col mb-4">
          <label htmlFor="bairroInput" className="form-label">
            Bairro
          </label>
          <input
            type="text"
            className="form-control"
            id="bairro"
            placeholder="Informe antes seu CEP"
            {...register("bairro")}
          />
          {errors.bairro ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.bairro.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="col mb-4">
          <label htmlFor="numero" className="form-label">
            Número
          </label>
          <input
            type="number"
            className="form-control"
            id="numero"
            placeholder="Número"
            {...register("numero")}
          />
          {errors.numero ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.numero.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="col mb-4">
          <label htmlFor="complemento" className="form-label">
            Complemento
          </label>
          <input
            type="text"
            className="form-control"
            id="complemento"
            placeholder="Informação opcional"
            {...register("complemento")}
          />
        </div>
      </div>
      <div className={`${isMobile ? "" : "row"}`}>
        <div className="col mb-4">
          <label htmlFor="cidadeInput" className="form-label">
            Cidade
          </label>
          <input
            type="text"
            className={`form-control disabled`}
            id="cidade"
            placeholder="Cidade"
            disabled
            {...register("cidade")}
          />
          {errors.cidade ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.cidade.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="col mb-4">
          <label htmlFor="estado" className="form-label">
            Estado
          </label>
          <input
            type="text"
            className={`form-control disabled`}
            id="estado"
            placeholder="Estado"
            disabled
            {...register("estado")}
          />
          {errors.estado ? (
            <div className="w-100 d-flex align-items-center gap-2 mt-4 validation-control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
              <p>{errors.estado.message}</p>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div
        className={`w-100 d-flex ${
          isMobile ? "flex-column mobile" : ""
        } justify-content-between buttons`}
      >
        <button
          type="button"
          className="btn mt-5 button-control button-prev"
          onClick={() => prevStep()}
        >
          Voltar
        </button>
        <button
          type="submit"
          className={`btn ${
            isMobile ? "mt-3" : "mt-5"
          } button-control button-next`}
        >
          Próximo
        </button>
      </div>
    </form>
  );
}

export default Step2;
